import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { useParams, useNavigate } from "react-router-dom";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import axios from "../utils/Axios";
import DataLoader from "../component/DataLoader";
import { jwtDecode } from "jwt-decode";




const getAccessTokenAndEmbedUrl = async (reportId, groupId, group_of) => {
  try {
    const response = await axios.post("/pbi-dashbord/accessToken", { reportId, groupId, dashboardType: group_of });
    return response.data;
  } catch (error) {
    console.error("Error fetching access token or embed URL", error);
    throw new Error("Failed to fetch access token or embed URL.");
  }
};



const PowerBIReportContainer = ({ reportId, groupId, group_of }) => {
  const [embedConfig, setEmbedConfig] = useState(null);
  const [report, setReport] = useState(null);
  const fetchEmbedConfig = async () => {
    try {
      const { access_token, embedUrl } = await getAccessTokenAndEmbedUrl(reportId, groupId, group_of);
      localStorage.setItem("token", access_token);
      // checkTokenExpiration();
      setEmbedConfig({
        type: "report",
        id: reportId,
        embedUrl: embedUrl,
        accessToken: access_token,
        tokenType: models.TokenType.Aad,
        settings: {
          panes: {
            filters: {
              visible: false,
            },
            pageNavigation: {
              visible: true,
            },
          },
          layout: {
            height: "100",
            width: "100",
          },
        },
      });
    } catch (error) {
      console.error("Error fetching access token and embed URL", error);
    }
  };


  // const checkTokenExpiration = () => {
  //     setTimeout(() => {
  //         fetchEmbedConfig();
  //     }, 15 * 60 * 1000); // 15 minutes
  // };


  setInterval(() => {
    window.location.reload();
  }, 900000);




  //   return () => clearInterval(intervalId);
  // }, []);



  useEffect(() => {
    fetchEmbedConfig(); // Initial data load

    // const intervalId = setInterval(() => {
    //   if (report) {
    //     console.log(report);
    //     // window.location.reload();
    //     report.refresh(); // Refresh the report every 5 seconds
    //   }
    // }, 900000); // 15 min min

    // return () => clearInterval(intervalId); // Cleanup the interval
  }, [report, reportId, groupId]);

  return (
    <div style={{ width: "100%", height: "calc(100vh - 80px)" }}>
      {embedConfig ? (
        <PowerBIEmbed
          embedConfig={embedConfig}
          cssClassName="report-style-class"
          getEmbeddedComponent={(embeddedReport) => {
            console.log("Report embedded successfully", embeddedReport);
            setReport(embeddedReport); // Set the report instance when embedded
          }}
          onError={(error) => {
            console.error("Error embedding the report", error);
          }}
        />
      ) : (
        <div className="flex flex-col items-center justify-center w-full h-full">
          <DataLoader message="Fetching Data..." size={60} color="green" className="flex items-center justify-center" animationSpeed="0.9s" />
        </div>
      )}
    </div>
  );
};

function PowerBI() {
  console.log("Niasdvdkscdldscsvfdsv");
  const { title, id, groupId: routeGroupId, group_of } = useParams();
  console.log("Niasdvdkscdldscsvfdsv", group_of);
  const navigate = useNavigate();
  // useEffect(() => {
  //   setInterval(() => {
  //    window.location.reload(); 
  //   },20000)
  // })
  const handleBackClick = () => {
    navigate(-1); // Navigate back 2 steps
  };

  useEffect(() => {
    if (id && routeGroupId) {
      localStorage.setItem("reportId", id);
      localStorage.setItem("groupId", routeGroupId);
    }
  }, [id, routeGroupId]);

  const savedReportId = localStorage.getItem("reportId");
  const savedGroupId = localStorage.getItem("groupId");

  const reportId = id || savedReportId;
  const groupId = routeGroupId || savedGroupId;

  if (!reportId || !groupId) {
    return (
      <div>
        <p>Error: Report or Group ID is missing</p>
      </div>
    );
  }

  return (
    <div id="app" className="min-h-screen relative bg-gray-100">
      <div className="w-full flex absolute top-0 md:top-2 items-center justify-between bg-transparent px-4">
        <button
          onClick={handleBackClick}
          className="text-2xl text-red-500  rounded-full min-w-12 h-12 flex items-center justify-center"
          aria-label="Go Back"
        >
          <div className="flex items-center gap-2 justify-center">
            <MdOutlineKeyboardBackspace className="text-[20px] bg-red-500 text-white p-1 hover:bg-red-400 hover:text-white rounded-full" />
            <p className="text-[12px]">Go Back</p>
          </div>
        </button>
        <div className="w-10"></div>
      </div>
      <div className="bg-white shadow-lg">
        <PowerBIReportContainer reportId={reportId} groupId={groupId} group_of={group_of?.toLowerCase()} />
      </div>
    </div>
  );
}

export default PowerBI